import * as React from 'react';

export function TimeSavings() {
  return (
    <section className="verdu-time">
      <style>{`
        .verdu-time {
          padding: 72px 24px;
          background: #fff;
        }
        .verdu-time-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .verdu-time h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .verdu-time .subtitle {
          font-size: 20px;
          font-weight: 600;
          color: #1EAA25;
          margin: 0 0 28px;
        }
        .verdu-time p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .verdu-time .benefit-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
        }
        .verdu-time .benefit-list li {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 16px;
          color: #333;
          padding: 10px 0;
          border-bottom: 1px solid #eee;
        }
        .verdu-time .benefit-list li:last-child {
          border-bottom: none;
        }
        .verdu-time .benefit-list li i {
          color: #1EAA25;
          font-size: 16px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .verdu-time h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="verdu-time-inner">
        <h2>15 horas semanales que podés usar para vender.</h2>
        <p className="subtitle">El tiempo que gastás en el Mercado es tiempo que no estás en tu local.</p>
        <p>
          Recorrer puestos, comparar precios, negociar, cargar cajones y volver.
          Todo eso lleva entre 2 y 3 horas cada vez que vas. Multiplicalo por la semana.
        </p>
        <p>Con Abasto Virtual:</p>
        <ul className="benefit-list">
          <li><i className="fa fa-check" /> Pedís desde el celular en minutos</li>
          <li><i className="fa fa-check" /> Recibís en tu local sin moverte</li>
          <li><i className="fa fa-check" /> Precios claros sin tener que regatear</li>
          <li><i className="fa fa-check" /> Más tiempo para atender a tus clientes</li>
        </ul>
      </div>
    </section>
  );
}
